module.exports = __webpack_public_path__ + "img/成果展示banner.3b147d75.png";